module.exports = __webpack_public_path__ + "static/media/Hi_freq_strip.21b90507.png";